<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>{{ $t("navigations.data entry") }}</h2>
    </div>
  </div>
  <customModal v-if="plannextvisitPopup == true" :containersm="true" @closeModal="closeplannextvisitModal()">
    <template #title>
      Plan Next Visit
    </template>
    <template #body>
      <div class="container mt-3">
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">Visit Name</label>
            <select class="form-select no-arrow" v-model="createvisitobj.visitName" disabled @change="changeVisitDate">
              <option selected value="">All</option>
              <option v-for="schedule in (getTreeState(createvisitobj.__treeKey).visitobj[createvisitobj.patientId]?.[createvisitobj.__patientIndex] || [])"
                :key="schedule.sheduleId" :value="schedule.visitName">
                {{ schedule.visitName }}
              </option>
            </select>
          </div>

          <!-- Planned Visit Date -->
          <div class="col-md-6 mb-3">
            <label class="form-label">Planned Visit Date</label>
            <input type="datetime-local" disabled v-model="oldvisitdatetDate" class="form-control" />
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">
              New Visit Date
              <sup><i class="fa fa-asterisk required"></i></sup>
            </label>
            <input type="datetime-local" v-model="newvisitDate" class="form-control" />
          </div>

        </div>

        <div class="mt-3">
          <h6 class="border-bottom pb-2 mb-3" style="font-size:13px; font-weight:600;">
            Visit Window
          </h6>

          <div class="row">
            <!-- Pre Visit Date -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Pre-Visit Date</label>
              <input type="datetime-local" v-model="preVisitDate" class="form-control" />
            </div>

            <!-- Post Visit Date -->
            <div class="col-md-6 mb-3">
              <label class="form-label">Post-Visit Date</label>
              <input type="datetime-local" v-model="postVisitDate" class="form-control" />
            </div>
          </div>
        </div>

        <div class="text-end mt-2">
          <button type="button" @click.prevent="Createnewvisitfun(createvisitobj)" class="btn btn-primary btn-sm px-4"
            :disabled="showLoader">
            <span v-if="!showLoader">Save</span>
            <span v-else>
              <i class="fa fa-spinner fa-spin"></i>
            </span>
          </button>
        </div>

      </div>
    </template>


  </customModal>

  <customModal v-if="ManageVisitPopup == true" :containersm="true" @closeModal="closeManageVisitModal()">
    <template #title>
      Manage Visit
    </template>
    <template #body>
      <div class="container mt-3">
        <div class="row justify-content-center">
          <div class="p-2">
            <div class="col-md-12 d-flex">
              <label class="form-label col-md-6">Visit Start Date<sup><i
                    class="fa fa-asterisk required"></i></sup></label>
              <input type="datetime-local" v-model="actualVisitStartDate" class="form-control col-md-6" />
            </div>

            <div class="col-md-12 d-flex mt-2">
              <label class="form-label col-md-6">Visit End Date</label>
              <input type="datetime-local" v-model="actualVisitEndDate" class="form-control col-md-6" />
            </div>

            <div class="col-md-12 text-start">
              <div class="form-check mt-4">
                <input class="form-check-input" type="checkbox" id="completedCheck" v-model="isCompleted" />
                <label class="form-check-label" for="completedCheck">
                  Mark this visit as completed
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col text-end">
                <button type="button" @click.prevent="updateactualvisitdates(managevisitobj)"
                  class="btn btn-primary btn-sm px-4" :disabled="showCreateLoader">
                  <span v-if="showCreateLoader == false">Save</span>
                  <span v-else><i class="fa fa-spinner fa-spin"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </template>
  </customModal>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row"></div>
    <div class="row">
      <EnterNewEcrfTree
        :sites="sites"
        :tree-states="treeStates"
        :all-form-list="allFormList"
        :roleprivileges="roleprivileges"
        :show-side-popup="showSidePopup"
        @editpatient="editpatient"
        :handlers="treeHandlers"
      />
      <ModifyExistingEcrfTree
        :sites="sites"
        :tree-states="treeStates"
        :handlers="treeHandlers"
      />
     
    </div>
  </div>
<submittedforms @showviewecrfpopup="showviewecrfpopup"></submittedforms>
  <!-- modal starts -->
  <div class="modal-wrapper">
    <div class="modal-container">
      <div class="titleclass">
        <h4 class="px-3 mt-1">{{ $t("navigations.add form") }}</h4>
        <div class="closebutton mt-1">
          <span class="tooltip-wrapper pointer" style="float:right">
            <i class="fa fa-times cursor-pointer" @click.prevent="closeModal"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </span>

        </div>
      </div>
      <div class="modelbody p-0">
        <!-- test -->
        <div class="mb-3 p-2">
          <div class="form-group">
            <div class="d-flex flex-column flex-lg-row">
              <div class="col-lg-12 my-2">
                <select class="form-control" placeholder="Search by Status" v-model="selectedTemplate">
                  <option value="" disabled selected>
                    {{ $t("navigations.select forms") }}
                  </option>
                  <option v-for="templates in templateList" :key="templates.templateId" :value="templates.templateId">
                    {{ templates.templateName }} ( {{ templates.version }}) - {{ templates.languageCode.toUpperCase() }}
                  </option>
                </select>
              </div>
            </div>

            <div class="d-flex justify-content-center my-3">
              <button class="save_btn py-1 px-4" @click.prevent="
                gotofillform(
                  selectedVisit.visit,
                  selectedVisit.subjectId,
                  selectedVisit.siteCode
                )
                ">
                {{ $t("navigations.fill form") }}
              </button>
            </div>
          </div>
        </div>
        <!-- test -->
      </div>
    </div>
  </div>
  <ChangeactivityStatusPopup v-if="showChangeActivity" :activitystatusreload="activitystatusreload"
    :currentstatus="currentactivitystatus" :activityid="selectedActivityid" @changeStatus="changedactivityStatus"
    @closeModal="closeChangeactivityModal()" />

  <CreateVideoCallSchedulePopUp v-if="CreateVideoCallSchedulePopUp" @closeModal="CreateVideoCallSchedulePopUp = false"
    :patientid="selectedPatientId" :fromPage="'FillForm'" />
  <CreateScheduleCyclePopUp v-if="CreateScheduleCyclePopUp" @closeModal="CreateScheduleCyclePopUp = false"
    :patientid="selectedPatientId" :cycleid="selectedCycleId" />

  <!-- Change schedule status  -->
  <ChangeSchedulestatus v-if="showChangeSchedule" :statusType="statusType" :changeStatus="changeStatus"
    :selectedScheduleId="scheduleId" :selectedFormId="selectedForm" @changeStatus="changedStatus()"
    @closeModal="closeChangeScheduleModal()" />
  <!-- End of Change schedule status  -->

  <!-- Visit form list modal starts -->
  <div class="modal__schedule__wrapper" v-if="sohowFormModal">
    <div class="modal__schedule__container-forms">
      <div class="modal__schedule__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.forms") }}</h4>
        <div class="col-lg-2">
          <span class="tooltip-wrapper pointer" style="float:right">
            <i class="fa fa-times cursor-pointer" @click.prevent="closeFormsModal()"></i>
            <span class="custom-tooltip closetooltipposition">Close</span>
          </span>

        </div>
      </div>
      <div class="modal-body overflow-block-form">
        <div class="form-group row my-lg-2">
          <div class="d-flex flex-column flex-lg-row mb-lg-0">
            <div class="col-lg-12" :class="{ 'max-scroll-300': formlist && formlist.length > 10 }">
              <table class="table features-table">
                <tbody>
                  <p v-if="formlist.data == ''" class="mb-0 text-center">
                    {{ $t("navigations.no forms added") }}
                  </p>
                  <tr v-for="(forms, formIndex) in formlist" :key="forms.sheduleId">
                    <td>{{ forms.templateName }} ( {{ forms.version }}) - {{ forms.languageCode.toUpperCase() }}</td>

                    <!-- <td>
                      
                      <span class="badge badge-grn" v-if="forms.visitStatus == 'Completed'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-danger" v-if="forms.visitStatus == 'Overdue'">{{ forms.visitStatus }}
                      </span>
                      <span class="badge badge-yellow" v-if="forms.visitStatus == 'Imminent'">{{ forms.visitStatus
                        }}</span>
                        <span class="badge badge-gray" v-if="forms.visitStatus == 'Withdrawn'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-blue" v-if="
                        forms.visitStatus == 'Planned'
                      ">{{ forms.visitStatus }}</span>
                      <span class="badge badge-orage" v-if="forms.visitStatus == 'Pending'">{{ forms.visitStatus }}
                      </span>
                    </td> -->
                    <td>
                      <span class="badge custom-tooltip-wrapper" @mouseenter="showPopover(`formsList-${formIndex}`)"
                        @mouseleave="hidePopover(`formsList-${formIndex}`)" :popovertarget="`formsList-${formIndex}`"
                        :style="`background-color: ${forms.formStatusHex || defaultBadgeColor}; color: black; anchor-name:--formsList-${formIndex};`">
                        {{ forms.formStatus }}

                      </span>
                      <span class="custom-tooltip-text" v-if="forms.formStatusDescription" popover
                        :id="`formsList-${formIndex}`" :style="{
                          position: 'fixed',
                          'position-anchor': '--formsList-' + formIndex
                        }">{{ forms.formStatusDescription }}</span>

                    </td>
                    <td class="text-center">
                      <i class="fa fa-plus-square edit-delete" title="Fill Form"
                        @click.prevent="goTovisitTemplate([forms], forms.patientId)"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Visit form list modal ends -->
  <!-- Visit form list modal starts -->
  <div class="modal__schedule__wrapper" v-if="sohowFormModalImminent">
    <div class="modal__schedule__container-forms">
      <div class="modal__schedule__title d-flex justify-content-between py-2 px-3">
        <h4 class="my-0">{{ $t("navigations.forms") }}</h4>
        <div class="cursor-pointer">
          <i class="fa fa-times" title="Close" @click.prevent="closeImminentFormsModal()">
          </i>
        </div>
      </div>
      <div class="modal-body overflow-block-form">
        <div class="form-group row my-lg-2">
          <div class="d-flex flex-column flex-lg-row mb-lg-0">
            <div class="col-lg-12" :class="{ 'max-scroll-300': formlist && formlist.length > 10 }">
              <table class="table features-table">
                <tbody>
                  <p v-if="formlist.data == ''" class="mb-0 text-center">
                    {{ $t("navigations.no forms added") }}
                  </p>
                  <tr v-for="forms in formlist" :key="forms.sheduleId">
                    <td>{{ forms.templateName }} ({{ forms.version }}) - {{ forms.languageCode.toUpperCase() }}</td>
                    <!-- <td>
                      <span class="badge badge-grn" v-if="forms.visitStatus == 'Completed'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-danger" v-if="forms.visitStatus == 'Overdue'">{{ forms.visitStatus }}
                      </span>
                      <span class="badge badge-yellow" v-if="forms.visitStatus == 'Imminent'">{{ forms.visitStatus
                        }}</span>
                        <span class="badge badge-gray" v-if="forms.visitStatus == 'Withdrawn'">{{ forms.visitStatus
                        }}</span>
                      <span class="badge badge-blue" v-if="
                        forms.visitStatus == 'Planned'
                      ">{{ forms.visitStatus }}</span>
                      <span class="badge badge-orage" v-if="forms.visitStatus == 'Pending'">{{ forms.visitStatus }}
                      </span>
                    </td> -->
                    <td>
                      <span class="badge custom-tooltip-wrapper"
                        @mouseenter="showPopover(`formsImminentList-${forms.sheduleId}`)"
                        @mouseleave="hidePopover(`formsImminentList-${forms.sheduleId}`)"
                        :popovertarget="`formsImminentList-${forms.sheduleId}`"
                        :style="`background-color: ${forms.formStatusHex || defaultBadgeColor}; color: black; anchor-name:--formsImminentList-${forms.sheduleId};`">
                        {{ forms.formStatus }}
                        <span class="custom-tooltip-text" v-if="forms.formStatusDescription" popover
                          :id="`formsImminentList-${forms.sheduleI}`" :style="{
                            position: 'fixed',
                            'position-anchor': '--formsImminentList-' + forms.sheduleI
                          }">{{ forms.formStatusDescription }}</span>
                      </span>

                    </td>
                    <td class="text-center">
                      <i class="fa fa-plus-square edit-delete" title="Fill Form"
                        @click.prevent="goTovisitTemplate([forms])"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Visit form list modal ends -->
<editecrffrompopup
v-if="showeditecrfformpopup"
closeoption="dataEntry"
:formsesid="ecrfformid"
isPatientVisit="0"
@closeeditecrfpopup="closeeditecrfpopup"
>

</editecrffrompopup>
<manageSubjectModal
  v-if="showPatientModal"
    @closeModal="closepatientmodel()"
    :patientId="selectededitPatientId"
    />
  <ManageVisit v-if="showManageVisitModal" :managevisitobj="managevisitobj" @saveVisit="refreshVisits"
    @closeModal="closeManageVisitModalNew" />
  <!-- unscheduled visit  modal start -->
  <UnscheduledVisitModal v-if="showUnscheduledVisitModal" :patientId="patientId" @refreshVisits="refreshVisits"
    @closeModal="closeUnscheduledVisitModal" />
  <!-- unscheduled visit  modal end -->
</template>
<script src="./DataEntry.js"></script>
<style scoped>
@import "../../assets/css/style.css";
@import "../../assets/bootstrap.css";
@import "../../assets/font-awesome/css/font-awesome.css";
@import "../Submit_Form/tree.css";

.max-scroll-300 {
  max-height: 300px;
  overflow-y: scroll;
}

/* Tooltip box */

.custom-tooltip-wrapper {
  position: relative
}

.custom-tooltip-text,
.custom-form-tooltip-text {
  position: absolute;
  inset: auto;
  margin: 0;
  bottom: anchor(top);
  right: anchor(right);
  background-color: #616161;
  color: white;
  padding: 6px 10px;
  font-size: 0.75rem;
  border-radius: 4px;
  border: none;
  max-width: 180px;
  white-space: normal;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-block-end: 4px;

}

.custom-tooltip-text:popover-open {
  display: grid;
}

/* CSS Popover Styles */

.visit-ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}

.visit-popup-menu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.visit-popup-menu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.visit-popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}

.visit-popup-menu>button {
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}

/* [popover]:popover-open {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    animation: fadeIn 0.2s ease-in-out;
  } */

.visit-popup-menu>.popup-menu-block:hover,
.popup-submenu>div:hover {
  background-color: #e4eaf9;
}

@position-try --bottom {
  inset: auto;
  bottom: anchor(top);
  right: anchor(left)
}

/* CSS Popover Styles */
.linkstyle {
  cursor: pointer;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 18px;
  top: 6px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(124px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.plan-side-popup>div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup>div:hover {
  background-color: #e4eaf9;
}

.modal-container {
  background: #fff;
  width: min(50%, 90%);
  border-radius: 4px;
  position: fixed;
  transition: all 0.3s ease-in-out;
  height: auto !important;
  margin-top: 200px;
}

.modelbody {
  overflow: unset !important;
}

.modelbody {
  background: #fff;
  /* background-color: aquamarine;  */
  margin: 0;
  padding: 5%;
}

.plan-side-popup {
  position: absolute;
  text-align: left;
  right: 17px;
  top: 12px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: min(90px, 90%);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(30%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 3000;
}

.badge-genre {
  background-color: #b6bdbf;
  color: #ffffff;
}

.badge-grn {
  background-color: #1ab394;
  color: #ffffff;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}

.overflow-block-form {
  width: 100%;
  padding: 8px 8px;
  overflow-x: scroll;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

.closetooltipposition {
  bottom: -10px !important;

}

</style>
